module.exports = __webpack_public_path__ + "static/media/sand_gor_slid.af713135.png";